import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';

const resizeObserverErr = window.onerror;
window.onerror = (msg, ...rest) => {
  if (typeof msg === "string" && msg.includes("ResizeObserver loop")) {
    return true; // suppress — this is harmless
  }
  return resizeObserverErr?.(msg, ...rest);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
